import React from 'react';
import { I18nManager } from 'react-native';
import { StyleProp, TextStyle } from 'react-native';
import { Colors } from 'react-native-paper';
import FontAwesomeIcon from 'react-native-vector-icons/FontAwesome5';
import styled from 'styled-components/native';

type Props = {
  name?: string;
  color?: string;
  size?: number;
  lineHeight?: number;
  direction?: 'rtl' | 'ltr';
  allowFontScaling?: boolean;
  style?: StyleProp<TextStyle>;
};

const Center = styled.View<{ size?: number }>`
  justify-content: center;
  align-items: center;
  width: ${({ size = 14 }) => size}px;
  height: ${({ size = 14 }) => size}px;
`;

const Component: React.FC<Props> = ({
  name,
  color = Colors.black,
  size = 14,
  direction,
  allowFontScaling,
  lineHeight,
  style,
}) => {
  if (!name) {
    return null;
  }
  let scaleX = direction === 'rtl' ? -1 : 1;
  let newName = name;
  let solid = false;
  if (I18nManager.isRTL) {
    if (newName.endsWith('-left')) {
      newName = newName.replace('-left', '-right');
    } else if (newName.endsWith('-right')) {
      newName = newName.replace('-right', '-left');
    } else if (newName.endsWith('-rtl')) {
      newName = newName.replace('-rtl', '');
      scaleX = -1;
    }
  } else {
    if (newName.endsWith('-rtl')) {
      newName = newName.replace('-rtl', '');
    }
  }

  if (newName.endsWith('-o')) {
    newName = newName.replace('-o', '');
    solid = true;
  }

  return (
    <Center size={size}>
      <FontAwesomeIcon
        allowFontScaling={allowFontScaling}
        name={newName}
        color={color}
        size={size}
        solid={solid}
        style={[
          {
            transform: [{ scaleX }],
            lineHeight,
          },
          style,
        ]}
      />
    </Center>
  );
};

Component.displayName = 'FontIcon';

export default Component;
